import React from 'react'
import {
  Col,
  Container,
  Row,
  Tooltip,
  Button,
  Icon,
  Tabs as ArchTabs,
  Accordion,
  AccordionRow,
  Table as PayPalTable,
  Toast,
  Badge,
  Banner,
  Alert,
  HeadingText,
} from '@paypalcorp/pp-react'
import ContentAccordion from '../../../../utils/ContentAccordion'
import TableACDCGA from './TableACDCGA'
import CardCurrencyBrandIntroACDC from '../CardCurrencyBrandIntroACDC'
import './accordion.css'

const TableACDCGAAccordion = () => {
  return (
    <div>
      <CardCurrencyBrandIntroACDC />
      <ContentAccordion>
        <AccordionRow
          heading="Card brand currency table"
          className="accordion-height-acdc"
        >
          <TableACDCGA />
        </AccordionRow>
      </ContentAccordion>
    </div>
  )
}

export default TableACDCGAAccordion
